const NORTH_PRAIRIE_DUE_FIELDS = [
  'NPPipeFabDue',
  'NPCSMDue',
  'NPSuctionLineDue',
  'NPInducerTubeDue',
  'NPBMXDue'
];

const normalizeNorthPrairieValue = (value) => {
  if (typeof value !== 'string') {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  return value.trim();
};

export const hasNorthPrairieDueDate = (job) => {
  if (!job) {
    return false;
  }

  return NORTH_PRAIRIE_DUE_FIELDS.some((field) => {
    const value = normalizeNorthPrairieValue(job[field]);
    if (value === '') {
      return false;
    }

    const dueDate = new Date(value);
    return !Number.isNaN(dueDate.getTime());
  });
};

export const isNorthPrairieViewJob = (job) => hasNorthPrairieDueDate(job);

const getEarliestNorthPrairieDueDate = (job) => {
  if (!job) {
    return null;
  }

  const dates = NORTH_PRAIRIE_DUE_FIELDS
    .map((field) => {
      const value = normalizeNorthPrairieValue(job[field]);
      if (value === '') {
        return null;
      }

      const dueDate = new Date(value);
      return Number.isNaN(dueDate.getTime()) ? null : dueDate;
    })
    .filter(Boolean);

  if (dates.length === 0) {
    return null;
  }

  return new Date(Math.min(...dates.map((date) => date.getTime())));
};

export const compareNorthPrairieDueDates = (leftJob, rightJob) => {
  const leftDue = getEarliestNorthPrairieDueDate(leftJob);
  const rightDue = getEarliestNorthPrairieDueDate(rightJob);

  if (!leftDue && !rightDue) return 0;
  if (!leftDue) return 1;
  if (!rightDue) return -1;

  return leftDue - rightDue;
};

export const sortJobsByNorthPrairieDue = (jobs) => {
  if (!Array.isArray(jobs)) {
    return [];
  }

  return [...jobs].sort(compareNorthPrairieDueDates);
};
